module.exports = __webpack_public_path__ + "static/media/cookies-bread.831f618e.jpg";